<template>
  <v-card class="mx-auto rounded-lg custom-card">
    <div class="d-flex align-center justify-space-between px-6 py-4">
      <h2 class="text-h5 font-weight-bold text-grey-darken-4">
        Logging Out...
      </h2>

      <v-btn
        icon
        variant="text"
        size="small"
        color="#475367"
        @click="toggleLogout"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-divider color="#e4e7ec"></v-divider>

    <div class="px-6 py-6">
      <p class="text-body-2 text-grey-darken-1 mb-6">
        Are you sure you want to log out of your PressOne account? You will need
        to login to regain access.
      </p>

      <div class="d-flex justify-center justify-md-end ga-3">
        <v-btn
          v-if="!authStore.isLoggingOut"
          variant="outlined"
          height="48"
          class="text-body-2 font-weight-medium"
          style="border-color: #e4e7ec; color: #475367"
          @click="toggleLogout"
        >
          No, cancel
        </v-btn>

        <router-link to="/sign-in">
          <v-btn
            height="48"
            class="submit-btn text-body-2 font-weight-medium"
            style="background-color: #dc2626; color: white"
            :loading="authStore.isLoggingOut"
            :disabled="authStore.isLoggingOut"
            @click="logout"
          >
            Yes, log me out
          </v-btn>
        </router-link>
      </div>
    </div>
  </v-card>
</template>

<script lang="ts" setup>
  import { handleError } from "@/api/handleError";
  import requestClient from "@/helpers/api/requestClient";
  import { useDialer } from "@/modules/dialer/composables/useDialer";
  import { useActivityStore } from "@/stores";
  import { useAuthStore } from "@/stores/auth.store";
  import { useTokenStore } from "@/stores/token.store";
  import { useRouter } from "vue-router";

  const emit = defineEmits(["toggleLogout"]);

  const authStore = useAuthStore();
  const activityStore = useActivityStore();
  const router = useRouter();
  const tokenStore = useTokenStore();

  const dialer = useDialer();

  const toggleLogout = () => {
    emit("toggleLogout");
  };

  const logout = async () => {
    try {
      authStore.isLoggingOut = true;

      const token = tokenStore.token;

      requestClient.abortRequest();

      await dialer.stop();

      if (activityStore?.centrifuge) {
        activityStore.centrifuge?.disconnect();
      }

      await authStore.logout();

      await authStore.CLEAR_X_REFRESH_TOKEN(token || "");
      await router.push("/sign-in");
    } catch (error) {
      handleError({ error });
    } finally {
      authStore.isLoggingOut = false;
    }
  };
</script>

<style scoped>
  .custom-card {
    border: 1px solid #e4e7ec;
    box-shadow: 0px 2px 8px 0px rgba(16, 24, 40, 0.06);
  }

  .submit-btn:hover {
    background-color: #b91c1c !important;
  }
</style>
